class BedConfigExamples extends HTMLElement {
  connectedCallback() {
    this.addEventListener('click', this.onClick);
  }

  disconnectedCallback() {
    this.removeEventListener('click', this.onClick);
  }

  onClick = (event) => {
    const button = event.target.closest('[data-apply-selection]');
    if (!button || !this.contains(button)) return;

    const card = button.closest('[data-bed-config-example]');
    if (!card) return;

    event.preventDefault();
    this.applyCardSelection(card);
  };

  revealMoreCards() {
    const hiddenCards = this.querySelectorAll('[data-show-more-item][hidden]');
    hiddenCards.forEach((card) => {
      card.hidden = false;
      card.classList.remove('hidden');
    });

    const footer = this.querySelector('[data-footer]');
    if (footer) footer.hidden = true;

    const slider = this.querySelector('slider-element');
    if (!slider) return;

    if (typeof slider.reset === 'function') {
      slider.reset();
    }

    // Attendre le reflow pour recalculer itemsToShow / débordement
    requestAnimationFrame(() => {
      if (typeof slider.updateButtons === 'function') {
        slider.updateButtons();
      }
      if (typeof slider.updateTabindex === 'function') {
        slider.updateTabindex();
      }
    });
  }

  applyCardSelection(card) {
    const dimensions = card.dataset.dimensions?.trim() || null;
    const color = card.dataset.color?.trim() || null;
    const headboardUrl = card.dataset.headboardUrl?.trim() || null;

    const configurator = document.querySelector('bed-configurator');

    if (configurator && typeof configurator.applySelection === 'function') {
      configurator.applySelection({ dimensions, color, headboardUrl });
      return;
    }

    if (configurator) {
      this.applySelectionFallback(configurator, { dimensions, color, headboardUrl });
      return;
    }

    // Hors page produit : on mémorise la sélection puis on ouvre la tête de lit
    if (headboardUrl) {
      try {
        sessionStorage.setItem('morphea_bed_config', JSON.stringify({ dimensions, color }));
      } catch (e) {}
      window.location.href = headboardUrl;
      return;
    }

    console.warn('[BedConfigExamples] Aucun bed-configurator trouvé sur la page.');
  }

  applySelectionFallback(configurator, { dimensions, color, headboardUrl }) {
    const currentUrl = configurator.dataset.productUrl || window.location.pathname;
    const needsRedirect =
      headboardUrl &&
      !this.urlsMatch(headboardUrl, currentUrl) &&
      !this.urlsMatch(headboardUrl, window.location.pathname);

    if (needsRedirect && typeof configurator.saveConfig === 'function') {
      configurator.saveConfig(dimensions, color);
      window.location.href = headboardUrl;
      return;
    }

    if (dimensions) {
      const dimBtn = configurator.querySelector(`[data-dimension-btn][value="${CSS.escape(dimensions)}"]`);
      if (dimBtn && !dimBtn.checked) {
        dimBtn.checked = true;
        dimBtn.dispatchEvent(new Event('change', { bubbles: true }));
      } else if (configurator.dimensionsSelect) {
        configurator.dimensionsSelect.value = dimensions;
        configurator.selectedOptions.dimensions = dimensions;
      }
    }

    if (color) {
      const fabric = color.includes(' - ') ? color.split(' - ')[0].trim() : null;
      if (fabric && configurator.fabricSelect) {
        configurator.fabricSelect.value = fabric;
        configurator.querySelectorAll('[data-fabric-btn]').forEach((btn) => {
          btn.checked = btn.value === fabric;
        });
        if (typeof configurator.filterColorsByFabric === 'function') {
          configurator.filterColorsByFabric(fabric, color);
        }
        if (typeof configurator.updateFabricDescription === 'function') {
          configurator.updateFabricDescription(fabric);
        }
      } else {
        const colorInput = configurator.querySelector(`[data-option-name="color"][value="${CSS.escape(color)}"]`);
        if (colorInput) {
          colorInput.checked = true;
          colorInput.dispatchEvent(new Event('change', { bubbles: true }));
        }
      }
    }

    if (typeof configurator.updateSummary === 'function') {
      configurator.updateSummary();
    }

    this.scrollToConfigurator(configurator);
  }

  urlsMatch(a, b) {
    if (!a || !b) return false;
    try {
      const pathA = new URL(a, window.location.origin).pathname.replace(/\/$/, '');
      const pathB = new URL(b, window.location.origin).pathname.replace(/\/$/, '');
      return pathA === pathB;
    } catch (e) {
      return a === b;
    }
  }

  scrollToConfigurator(configurator) {
    requestAnimationFrame(() => {
      configurator.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });
  }
}

customElements.define('bed-config-examples', BedConfigExamples);
